import React from 'react'

export const UpdateTag = () => {
  return (
    <span
      className="font-bold text-white text-[11px] px-1 py-[2px] rounded-[4px]"
      style={{
        background: `linear-gradient(to right,#6095FF,#00CBB3)`,
      }}
    >
      UPDATE
    </span>
  )
}
